import { Controller } from '@hotwired/stimulus'

// The htmx-request class is normally added to the form triggering the request, but it is not added to the
// element inside the form that triggered the submit, and we depend on this class to be able to show the htmx indicator (loading icon).
// This is being used on quizzes, to show the loading icon on strikeout checkbox/icon, options and all question buttons on the sidebar.
export default class extends Controller {
  initialize() {
    const form = this.element

    // Forms with hx-trigger="change" do not fire the submit event, therefore they need to listen to 'change'.
    if (form.getAttribute("hx-trigger") === "change") {
      form.addEventListener("change", (event) => {
        event.target.classList.add("htmx-request")
      })

    // Forms triggered with submit will trigger the submit event.
    } else {
      form.addEventListener("submit", (event) => {
        event.submitter.classList.add("htmx-request")
      })
    }
  }
}
